import { z } from 'zod';
/**
 * Nhóm việc do người dùng tự tạo — APM-1306.
 *
 * ## Nhóm KHÔNG phải một task
 *
 * Bản thiết kế đầu dùng task tầng 1 làm nhóm (`parent_id`). Nó sai theo cách
 * khó thấy: một nhóm khi đó **là** một task, nên nó có ngày, có người phụ
 * trách, có tiến độ, và nó xuất hiện trong burndown, trong đường găng, trong
 * velocity. Yêu cầu thực tế là một cái **hộp có tên** để gom việc — giống
 * playlist — chứ không phải biến "Pha 1" thành một việc ai đó phải làm.
 *
 * Hệ quả có chủ đích: nhóm không mang ngày, không mang tiến độ, và **không**
 * xuất hiện trong bất kỳ phép đo nào. Ngày và tiến độ của một nhóm đều suy ra
 * được từ task bên trong; một con số nhập tay cạnh một con số suy ra là hai
 * nguồn sự thật cho cùng một câu hỏi.
 */
export const TaskGroupView = z.object({
    id: z.uuid(),
    projectId: z.uuid(),
    name: z.string(),
    position: z.number().int().nonnegative(),
    /** Số task đang trong nhóm — để hiện "(4)" cạnh tên mà không phải đếm ở client. */
    taskCount: z.number().int().nonnegative(),
});
export const CreateTaskGroupInput = z.object({
    name: z.string().trim().min(1).max(120),
    /**
     * Gom luôn những task này vào nhóm mới.
     *
     * Có mặt vì đó là **cách người dùng thật sự tạo nhóm**: tích vài task trên
     * danh sách rồi bấm "gom nhóm". Tách thành hai lời gọi (tạo nhóm, rồi gán)
     * thì một nhóm rỗng sẽ nằm lại nếu lời gọi thứ hai lỗi.
     */
    taskIds: z.array(z.uuid()).max(200).default([]),
});
export const RenameTaskGroupInput = z.object({
    name: z.string().trim().min(1).max(120),
});
/** Gán một lô task vào nhóm, hoặc `null` để bỏ khỏi nhóm. */
export const AssignTaskGroupInput = z.object({
    taskIds: z.array(z.uuid()).min(1).max(200),
    groupId: z.uuid().nullable(),
});
//# sourceMappingURL=task-group.js.map